import ProcessingExternalHttpApiClient from '@acme/external-processing-api-client';
import config from 'src/config';

const client = new ProcessingExternalHttpApiClient(config.apiUrl);

export default client;
